import type { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import type { TournamentsSliceState } from './tournaments-store';
import { fetchChampionships, fetchAndAppendChampionships } from 'modules/tournaments/store/tournaments/actions';
import { appendBatch } from 'shared/utils/pagination';

type ReducerBuilder = ActionReducerMapBuilder<TournamentsSliceState>;

export function createFetchChampionshipsReducer(builder: ReducerBuilder) {
  builder.addCase(fetchChampionships.pending, (state) => {
    state.isLoading = true;
  });

  builder.addCase(fetchChampionships.fulfilled, (state) => {
    state.isLoading = false;
    state.isLoaded = true;
  });

  builder.addCase(fetchChampionships.rejected, (state) => {
    state.isLoading = false;
    state.isLoaded = false;
  });
}

// Редьюсеры для ленивой постраничной ленты championships
export function createPagedChampionshipsReducers(builder: ReducerBuilder) {
  builder.addCase(fetchAndAppendChampionships.pending, (state, action) => {
    const scopeKey = action.meta.arg.scopeKey as string;
    state.paged.loadingByScope[scopeKey] = true;
    state.paged.errorByScope[scopeKey] = undefined;
  });

  builder.addCase(fetchAndAppendChampionships.fulfilled, (state, action) => {
    const { scopeKey, batch, limit } = action.payload as { scopeKey: string; batch: any[]; limit: number };
    state.paged.loadingByScope[scopeKey] = false;
    appendBatch(state.paged.championships as any, scopeKey, batch, limit);
    state.isLoaded = true;
  });

  builder.addCase(fetchAndAppendChampionships.rejected, (state, action) => {
    const scopeKey = action.meta.arg.scopeKey as string;
    state.paged.loadingByScope[scopeKey] = false;
    state.paged.errorByScope[scopeKey] = String(action.payload ?? action.error.message ?? 'Unknown error');
  });
}
